/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import EasySwipe from 'react-easy-swipe';
import { Modal, useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import CloseIcon from '@shared/assets/icons/CloseIcon';
interface ModalBannerDoneProps {
  open: boolean;
  handleClose: () => void;
  title: string;
  content: React.ReactNode;
}
const ModalCyber: FC<ModalBannerDoneProps> = ({
  open,
  handleClose,
  title,
  content
}) => {
  const [isClosing, setIsClosing] = useState(true);
  const [swipeDirection, setSwipeDirection] = useState('');
  const {
    isMobile
  } = useBreakpoint();
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    if (!open) return;
    setIsClosing(false);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={isMobile ? handleCloseModal : handleClose} closeIcon={<CloseIcon />} size="md">
      {/* @ts-ignore */}
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Heading>{title}</Heading>

          <Spacer space={48} spacetablet={48} spacemob={32} />
          <Wrapper>{content}</Wrapper>
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
export default ModalCyber;
interface StyledModalProps {
  isClosing: boolean;
  open: boolean;
}
const _exp = /*#__PURE__*/() => Modal;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.secondary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  isClosing
}) => isClosing ? 'translateY(100%)' : 'translateY(0)';
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const StyledModal = withTheme(/*#__PURE__*/styled(_exp())({
  name: "StyledModal",
  class: "s166k2hh",
  propsAsIs: true,
  vars: {
    "s166k2hh-0": [_exp2()],
    "s166k2hh-1": [_exp3()],
    "s166k2hh-2": [_exp7(), "px"],
    "s166k2hh-3": [_exp5()],
    "s166k2hh-4": [_exp6(), "px"],
    "s166k2hh-5": [_exp8()],
    "s166k2hh-6": [_exp9()],
    "s166k2hh-7": [_exp0()]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "hlq860s",
  propsAsIs: false,
  vars: {
    "hlq860s-0": [_exp1()],
    "hlq860s-1": [_exp10(), "px"],
    "hlq860s-2": [_exp11()],
    "hlq860s-3": [_exp12(), "px"],
    "hlq860s-4": [_exp13()]
  }
}));
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w78el98",
  propsAsIs: false
});

require("./ModalCyber.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ModalCyber.tsx");